import React from "react";
import { CONTACT, IMAGES } from "../../config";

export function Footer() {
  const wa = `${CONTACT.whatsappBase}?text=${encodeURIComponent("Hi! I have a question about DMediaClub.")}`;
  return (
    <footer className="bg-cream text-charcoal pt-16 pb-28 lg:pb-14 border-t-2 border-berry/15" data-testid="site-footer">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12">
          <div className="md:col-span-5">
            <img src={IMAGES.logo} alt="DMediaClub logo" className="h-10 w-auto mb-5" />
            <p className="display text-2xl text-berry">Created to create.</p>
            <p className="mt-4 text-sm text-charcoal/70 max-w-sm">A creative studio and workshop space for rent in Orlando — for workshops, classes, content creation, and creative community events.</p>
          </div>
          <div className="md:col-span-3">
            <p className="overline text-berry mb-4">Visit</p>
            <p className="text-sm text-charcoal/80">DMediaClub<br />{CONTACT.addressLine1}<br />{CONTACT.addressLine2}</p>
          </div>
          <div className="md:col-span-4">
            <p className="overline text-berry mb-4">Contact</p>
            <div className="space-y-2 text-sm">
              <p>Phone / WhatsApp: <a href={CONTACT.phoneLink} className="text-berry hover:underline" data-testid="footer-phone">{CONTACT.phoneDisplay}</a></p>
              <p>Email: <a href={CONTACT.emailLink} className="text-berry hover:underline break-all" data-testid="footer-email">{CONTACT.email}</a></p>
              <div className="flex flex-wrap gap-x-5 gap-y-2 pt-3 text-charcoal/70">
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="hover:text-berry">Instagram</a>
                <a href={wa} target="_blank" rel="noreferrer" className="hover:text-berry">WhatsApp</a>
                <a href="/rental-guidelines" className="hover:text-berry" data-testid="footer-rental-guidelines">Rental Guidelines</a>
                <a href={CONTACT.emailLink} className="hover:text-berry">Contact</a>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-6 border-t-2 border-berry/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-charcoal/50">
          <p>© {new Date().getFullYear()} DMediaClub · Orlando, Florida</p>
          <p>Creative studio & workshop space for rent in Orlando</p>
        </div>
      </div>
    </footer>
  );
}
